import { render, staticRenderFns } from "./TableCosts.vue?vue&type=template&id=9ae6a48a&"
import script from "./TableCosts.vue?vue&type=script&lang=js&"
export * from "./TableCosts.vue?vue&type=script&lang=js&"
import style0 from "./TableCosts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports